export interface InsuranceDestination {
  countryCode: string
}

/**
 * Arch v3.1 supports only one destination per quote: the primary one.
 * `countryCodes` comes from `get_country_codes_by_city_ids` in itinerary order,
 * so the first entry is the first-arrival country.
 */
export function toPrimaryDestination(countryCodes: { country_code?: string }[] | null | undefined): InsuranceDestination[] {
  const first = (Array.isArray(countryCodes) ? countryCodes : []).find((c) => c?.country_code)
  return first ? [{ countryCode: first.country_code as string }] : []
}
